import { render, staticRenderFns } from "./signal.vue?vue&type=template&id=4ca328ac&scoped=true&"
import script from "./signal.vue?vue&type=script&lang=js&"
export * from "./signal.vue?vue&type=script&lang=js&"
import style0 from "./signal.vue?vue&type=style&index=0&id=4ca328ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca328ac",
  null
  
)

export default component.exports